<template>
  <div class="MdIco fl0"
    :class="[
      icon.position === 'absolute' ? 'ExAbs' : '',
      marginClass,
      sizeClass,
      offsetTopClass,
      offsetBottomClass,
      offsetStartClass,
      offsetEndClass,
      hoverPath === parentPath + 'icon' ? 'on-hover' : '',
      !isAdmin && editPath === parentPath + 'icon' ? 'on-edit' : ''
    ]"
    :style="styles"
    @click="selectNode(icon, parentPath + 'icon')"
  >
    <div>
      <span :style="{
        backgroundImage: `url('${base64Image || proxiedImageUrl}')`,
        width: aspectRatio,
      }"></span>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageIcon } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class Icon extends Vue {
  @Prop()
  icon!: IFlexMessageIcon

  @Prop()
  parentLayout!: string

  @Prop()
  direction!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  base64Image: string | null = null

  get proxiedImageUrl() {
    if (this.icon.url) {
      const baseUrl = process.env.VUE_APP_API_ENDPOINT
      return `${baseUrl}v1/proxy_image?url=` + encodeURIComponent(this.icon.url)
    }
    return ''
  }

  get marginClass() {
    if (this.direction === 'rtl') {
      if (this.icon.margin === 'none') {
        return 'ExMgnRNone'
      } else if (this.icon.margin === 'xs') {
        return 'ExMgnRXs'
      } else if (this.icon.margin === 'sm') {
        return 'ExMgnRSm'
      } else if (this.icon.margin === 'md') {
        return 'ExMgnRMd'
      } else if (this.icon.margin === 'lg') {
        return 'ExMgnRLg'
      } else if (this.icon.margin === 'xl') {
        return 'ExMgnRXl'
      } else if (this.icon.margin === 'xxl') {
        return 'ExMgnRXXl'
      }
    } else {
      if (this.icon.margin === 'none') {
        return 'ExMgnLNone'
      } else if (this.icon.margin === 'xs') {
        return 'ExMgnLXs'
      } else if (this.icon.margin === 'sm') {
        return 'ExMgnLSm'
      } else if (this.icon.margin === 'md') {
        return 'ExMgnLMd'
      } else if (this.icon.margin === 'lg') {
        return 'ExMgnLLg'
      } else if (this.icon.margin === 'xl') {
        return 'ExMgnLXl'
      } else if (this.icon.margin === 'xxl') {
        return 'ExMgnLXXl'
      }
    }
  }

  get sizeClass() {
    if (this.icon.size === 'xxs') {
      return 'ExXXs'
    } else if (this.icon.size === 'xs') {
      return 'ExXs'
    } else if (this.icon.size === 'sm') {
      return 'ExSm'
    } else if (this.icon.size === 'md') {
      return 'ExMd'
    } else if (this.icon.size === 'lg') {
      return 'ExLg'
    } else if (this.icon.size === 'xl') {
      return 'ExXl'
    } else if (this.icon.size === 'xxl') {
      return 'ExXXl'
    } else if (this.icon.size === '3xl') {
      return 'Ex3Xl'
    } else if (this.icon.size === '4xxl') {
      return 'Ex4Xl'
    } else if (this.icon.size === '5xl') {
      return 'Ex5Xl'
    }
    return ''
  }

  get aspectRatio() {
    if (this.icon.aspectRatio) {
      const [width, height] = this.icon.aspectRatio.split(':').map(Number)
      return width / height + 'em'
    }
    return '1em'
  }

  get offsetTopClass() {
    if (this.icon.offsetTop === 'none') {
      return 'ExTNone'
    } else if (this.icon.offsetTop === 'xs') {
      return 'ExTXs'
    } else if (this.icon.offsetTop === 'sm') {
      return 'ExTSm'
    } else if (this.icon.offsetTop === 'md') {
      return 'ExTMd'
    } else if (this.icon.offsetTop === 'lg') {
      return 'ExTLg'
    } else if (this.icon.offsetTop === 'xl') {
      return 'ExTXl'
    } else if (this.icon.offsetTop === 'xxl') {
      return 'ExTXXl'
    } else {
      return ''
    }
  }

  get offsetBottomClass() {
    if (this.icon.offsetBottom === 'none') {
      return 'ExBNone'
    } else if (this.icon.offsetBottom === 'xs') {
      return 'ExBXs'
    } else if (this.icon.offsetBottom === 'sm') {
      return 'ExBSm'
    } else if (this.icon.offsetBottom === 'md') {
      return 'ExBMd'
    } else if (this.icon.offsetBottom === 'lg') {
      return 'ExBLg'
    } else if (this.icon.offsetBottom === 'xl') {
      return 'ExBXl'
    } else if (this.icon.offsetBottom === 'xxl') {
      return 'ExBXXl'
    } else {
      return ''
    }
  }

  get offsetStartClass() {
    if (this.direction === 'rtl') {
      if (this.icon.offsetStart === 'none') {
        return 'ExRNone'
      } else if (this.icon.offsetStart === 'xs') {
        return 'ExRXs'
      } else if (this.icon.offsetStart === 'sm') {
        return 'ExRSm'
      } else if (this.icon.offsetStart === 'md') {
        return 'ExRMd'
      } else if (this.icon.offsetStart === 'lg') {
        return 'ExRLg'
      } else if (this.icon.offsetStart === 'xl') {
        return 'ExRXl'
      } else if (this.icon.offsetStart === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    } else {
      if (this.icon.offsetStart === 'none') {
        return 'ExLNone'
      } else if (this.icon.offsetStart === 'xs') {
        return 'ExLXs'
      } else if (this.icon.offsetStart === 'sm') {
        return 'ExLSm'
      } else if (this.icon.offsetStart === 'md') {
        return 'ExLMd'
      } else if (this.icon.offsetStart === 'lg') {
        return 'ExLLg'
      } else if (this.icon.offsetStart === 'xl') {
        return 'ExLXl'
      } else if (this.icon.offsetStart === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    }
  }

  get offsetEndClass() {
    if (this.direction === 'rtl') {
      if (this.icon.offsetEnd === 'none') {
        return 'ExLNone'
      } else if (this.icon.offsetEnd === 'xs') {
        return 'ExLXs'
      } else if (this.icon.offsetEnd === 'sm') {
        return 'ExLSm'
      } else if (this.icon.offsetEnd === 'md') {
        return 'ExLMd'
      } else if (this.icon.offsetEnd === 'lg') {
        return 'ExLLg'
      } else if (this.icon.offsetEnd === 'xl') {
        return 'ExLXl'
      } else if (this.icon.offsetEnd === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    } else {
      if (this.icon.offsetEnd === 'none') {
        return 'ExRNone'
      } else if (this.icon.offsetEnd === 'xs') {
        return 'ExRXs'
      } else if (this.icon.offsetEnd === 'sm') {
        return 'ExRSm'
      } else if (this.icon.offsetEnd === 'md') {
        return 'ExRMd'
      } else if (this.icon.offsetEnd === 'lg') {
        return 'ExRLg'
      } else if (this.icon.offsetEnd === 'xl') {
        return 'ExRXl'
      } else if (this.icon.offsetEnd === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    }
  }

  get currentNodePath() {
    return this.parentPath + 'icon'
  }

  get styles() {
    const iconStyles: Record<string, string|number|undefined> = {}

    iconStyles.cursor = 'pointer'
    iconStyles.top = this.icon.offsetTop
    iconStyles.bottom = this.icon.offsetBottom
    if (this.direction === 'rtl') {
      iconStyles.left = this.icon.offsetEnd
      iconStyles.right = this.icon.offsetStart
    } else {
      iconStyles.left = this.icon.offsetStart
      iconStyles.right = this.icon.offsetEnd
    }

    return iconStyles
  }

  @Watch('icon.url', { immediate: true })
  async fetchBase64Image() {
    if (this.proxiedImageUrl) {
      this.base64Image = await this.loadImageAsBase64(this.proxiedImageUrl)
    }
  }

  async loadImageAsBase64(url: string): Promise<string | null> {
    const response = await fetch(url)
    const blob = await response.blob()

    return await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        const result = reader.result
        if (typeof result === 'string') {
          resolve(result)
        } else {
          resolve(null)
        }
      }
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  async mounted() {
    this.$emit('initListNode', this.currentNodePath)
    await this.fetchBase64Image()
  }
}
</script>

<style scoped lang="scss">

</style>
